export default __webpack_public_path__ + "static/media/ElectroplatingImg.ae812481.jpg";